import * as type from "./questionTypes";

export const tippingMidway = {
  type: type.tip
};

export const teamNameInput = {
  type: type.teamName
};

export const rateUsMidway = {
  type: type.rateUs
};

export const coursePayment = {
  type: type.payUs
};